export const REPORT_CONSUMPTION_SHOTS_REQUEST = "REPORT_CONSUMPTION_SHOTS_REQUEST";
export const REPORT_CONSUMPTION_SHOTS_SUCCESS = "REPORT_CONSUMPTION_SHOTS_SUCCESS";
export const REPORT_CONSUMPTION_SHOTS_FAILURE = "REPORT_CONSUMPTION_SHOTS_FAILURE";

export const REPORT_TRANSACTIONS_REQUEST = "REPORT_TRANSACTIONS_REQUEST";
export const REPORT_TRANSACTIONS_SUCCESS = "REPORT_TRANSACTIONS_SUCCESS";
export const REPORT_TRANSACTIONS_FAILURE = "REPORT_TRANSACTIONS_FAILURE";

export const REPORT_WHOLESALER_MONTH_REPORT_REQUEST = "REPORT_WHOLESALER_MONTH_REPORT_REQUEST";
export const REPORT_WHOLESALER_MONTH_REPORT_SUCCESS = "REPORT_WHOLESALER_MONTH_REPORT_SUCCESS";
export const REPORT_WHOLESALER_MONTH_REPORT_FAILURE = "REPORT_WHOLESALER_MONTH_REPORT_FAILURE";

export const REPORT_WHOLESALER_WEEK_REPORT_REQUEST = "REPORT_WHOLESALER_WEEK_REPORT_REQUEST";
export const REPORT_WHOLESALER_WEEK_REPORT_SUCCESS = "REPORT_WHOLESALER_WEEK_REPORT_SUCCESS";
export const REPORT_WHOLESALER_WEEK_REPORT_FAILURE = "REPORT_WHOLESALER_WEEK_REPORT_FAILURE";

export const REPORT_WHOLESALER_REPORT_REQUEST = "REPORT_WHOLESALER_REPORT_REQUEST";
export const REPORT_WHOLESALER_REPORT_SUCCESS = "REPORT_WHOLESALER_REPORT_SUCCESS";
export const REPORT_WHOLESALER_REPORT_FAILURE = "REPORT_WHOLESALER_REPORT_FAILURE";

export const REPORT_TRANSACTIONS_SEARCH_REQUEST = "REPORT_TRANSACTIONS_SEARCH_REQUEST";
export const REPORT_TRANSACTIONS_SEARCH_SUCCESS = "REPORT_TRANSACTIONS_SEARCH_SUCCESS";
export const REPORT_TRANSACTIONS_SEARCH_FAILURE = "REPORT_TRANSACTIONS_SEARCH_FAILURE";

export const REPORT_CONSUMPTION_SHOTS_SEARCH_REQUEST = "REPORT_CONSUMPTION_SHOTS_SEARCH_REQUEST";
export const REPORT_CONSUMPTION_SHOTS_SEARCH_SUCCESS = "REPORT_CONSUMPTION_SHOTS_SEARCH_SUCCESS";
export const REPORT_CONSUMPTION_SHOTS_SEARCH_FAILURE = "REPORT_CONSUMPTION_SHOTS_SEARCH_FAILURE";

//Wholesaler Date Search
export const WHOLESALER_REPORT_MONTH_DATE_SEARCH_REQUEST = "WHOLESALER_REPORT_MONTH_DATE_SEARCH_REQUEST";
export const WHOLESALER_REPORT_MONTH_DATE_SEARCH_SUCCESS = "WHOLESALER_REPORT_MONTH_DATE_SEARCH_SUCCESS";
export const WHOLESALER_REPORT_MONTH_DATE_SEARCH_FAILURE = "WHOLESALER_REPORT_MONTH_DATE_SEARCH_FAILURE";

export const WHOLESALER_REPORT_WEEK_DATE_SEARCH_REQUEST = "WHOLESALER_REPORT_WEEK_DATE_SEARCH_REQUEST";
export const WHOLESALER_REPORT_WEEK_DATE_SEARCH_SUCCESS = "WHOLESALER_REPORT_WEEK_DATE_SEARCH_SUCCESS";
export const WHOLESALER_REPORT_WEEK_DATE_SEARCH_FAILURE = "WHOLESALER_REPORT_WEEK_DATE_SEARCH_FAILURE";

export const WHOLESALER_REPORT_DATE_SEARCH_REQUEST = "WHOLESALER_REPORT_DATE_SEARCH_REQUEST";
export const WHOLESALER_REPORT_DATE_SEARCH_SUCCESS = "WHOLESALER_REPORT_DATE_SEARCH_SUCCESS";
export const WHOLESALER_REPORT_DATE_SEARCH_FAILURE = "WHOLESALER_REPORT_DATE_SEARCH_FAILURE";

//Wholesaler Search
export const REPORT_WHOLESALER_REPORT_SEARCH_REQUEST = "REPORT_WHOLESALER_REPORT_SEARCH_REQUEST";
export const REPORT_WHOLESALER_REPORT_SEARCH_SUCCESS = "REPORT_WHOLESALER_REPORT_SEARCH_SUCCESS";
export const REPORT_WHOLESALER_REPORT_SEARCH_FAILURE = "REPORT_WHOLESALER_REPORT_SEARCH_FAILURE";